import { type MailboxInfo } from 'owa-client-types';
import getRewardsPointsStore from '../store/rewardsPointsStore';
import getRewardsAccountKey from '../utils/getRewardsAccountKey';
import {
    REWARDS_BUTTON_CHROME_WIDTH_PX,
    REWARDS_MEDAL_ONLY_WIDTH_PX,
} from '../utils/rewardsButtonWidthConstants';

// Width, in pixels, for the Rewards header button. Returns the medal-only width until the balance
// resolves (so the button starts narrow and expands once), then adds the measured points-text width.
// Reads the observable store, so callers must evaluate it inside a MobX-tracked context.
export default function getRewardsButtonWidth(moduleContextMailboxInfo: MailboxInfo): number {
    const key = getRewardsAccountKey(moduleContextMailboxInfo);
    const pointsWidth = getRewardsPointsStore().pointsWidthByAccount[key];
    if (pointsWidth == null) {
        return REWARDS_MEDAL_ONLY_WIDTH_PX;
    }
    return REWARDS_BUTTON_CHROME_WIDTH_PX + pointsWidth;
}
